import { prefersReducedMotion } from '../utilities/ui-utils.js';
function startAnimations(el, keyframes, options) {
    return new Promise(resolve => {
        if ((options === null || options === void 0 ? void 0 : options.duration) === Infinity) {
            throw new Error('Promise-based animations must be finite.');
        }
        const animation = el.animate(keyframes, {
            ...options,
            duration: prefersReducedMotion() ? 0 : options.duration,
        });
        animation.addEventListener('cancel', resolve, { once: true });
        animation.addEventListener('finish', resolve, { once: true });
    });
}
function stopAnimations(el) {
    return Promise.all(el.getAnimations().map((animation) => new Promise(resolve => {
        const handleAnimationEvent = requestAnimationFrame(resolve);
        animation.addEventListener('cancel', () => handleAnimationEvent, { once: true });
        animation.addEventListener('finish', () => handleAnimationEvent, { once: true });
        animation.cancel();
    })));
}
export { startAnimations, stopAnimations };
